import {
  Box,
  VStack,
  Image,
  Button,
  Grid,
  Text,
  Flex,
  HStack,
  Avatar,
  Stack,
  Card,
  Spinner,
  Textarea,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { enhancePrompt, GettingAllModels, waveflowApi } from "../../allApi/api";
import preetyy from "../../assets/waveflowmain/preetyy.png";
import generate from "../../assets/waveflowmain/generate.png";
import { useDispatch } from "react-redux";
import {
  waveflowclearefetchagentsData,
  waveFlowdataAdd,
  waveflowDataTrigger,
} from "../../redux/reducer/waveFlow";
import LoadingForWaveFlow from "./WaveFlowLoader";
import DownloadJsonFile from "../../components/DownLoadBtn/DownloadJsonFile";
import { commonStyle } from "../../styles/commonStyle.js";
import { motion } from "framer-motion";
import { useCustomTost } from "../../utiils/useCustomTost.js";
import PreDefinedTool from "../../components/ToolsData/PredEfinedTool.jsx";
import { WarningIcon } from "@chakra-ui/icons";

function Waveflow({ setData }) {
  const [allChatData, setAllChatData] = useState([]);
  const [queChat, setQueChat] = useState("");
  const [submitBtn, setSubmitBtn] = useState(false);
  const [waveflowInput, setwaveflowInput] = useState(false);
  const [dataset, setdataset] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [enahancePromptLoading, setEnahancePromptLoading] = useState(false);
  const [errorEmptyInput, seterrorEmptyInput] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const waveflowRef = useRef();

  const toast = useCustomTost();

  function truncateText(text, charLimit) {
    if (text?.length > charLimit) {
      return text.slice(0, charLimit) + "...";
    }
    return text;
  }

  const chatApiCall = async (question, index) => {
    setLoading(true);
    setdataset([]);
    setData([]);
    try {
      const res = await waveflowApi({
        prompt: question,
        num_agents: Number(selectedValue) || "",
      });
      const answer = res;
      if (!answer?.agents || answer?.agents?.length < 0) {
        setError("Something Went Wrong, agent are not created");
      } else if (answer?.agents?.length > 0) {
        dispatch(waveFlowdataAdd(answer?.agents));
        dispatch(waveflowclearefetchagentsData());
        dispatch(waveflowDataTrigger(answer?.session_id));
        localStorage.setItem("session_id", answer?.session_id);
        setdataset(answer?.agents);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setdataset([]);

    try {
      const data = await GettingAllModels();

      if (!data?.models || data.models.length === 0) {
        toast("Warning!", "Please add at least one model.", "warning");
        return;
      }

      if (!queChat) {
        seterrorEmptyInput("Input field is required");
        return;
      }

      seterrorEmptyInput("");

      const textarea = waveflowRef.current;
      textarea.style.height = "45px";
      setwaveflowInput(true);

      if (queChat.trim()) {
        setAllChatData([
          ...allChatData,
          { que: queChat, ans: "", loading: true },
        ]);
        setSubmitBtn(true);
      }
    } catch (error) {
      console.error("Error fetching models:", error);
      toast("Error", "Something went wrong while fetching models", "error");
      setLoading(false);
    }
  };

  const fadeIn = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const enhancePrompHandle = async () => {
    if (!queChat) {
      seterrorEmptyInput("Input field is required");
      return;
    }
    seterrorEmptyInput("");
    setEnahancePromptLoading(true);
    try {
      const res = await enhancePrompt({
        prompt: queChat,
      });
      setQueChat(res?.enhanced_prompt);
    } catch (error) {
    } finally {
      setEnahancePromptLoading(false);
    }
  };

  const handleQueryWaveFlow = (e) => {
    setQueChat(e.target.value);
    const textarea = waveflowRef.current;
    if (textarea) {
      textarea.style.height = "45px";
      textarea.style.height = `${Math.min(textarea.scrollHeight, 100)}px`;
    }
  };

  useEffect(() => {
    if (submitBtn) {
      const currentIndex = allChatData?.length - 1;
      chatApiCall(queChat, currentIndex);
      setSubmitBtn(false);
    }
  }, [submitBtn]);

  return (
    <>
      {/* <UserRide /> */}
      <VStack spacing={1} w={"100%"} h={"80vh"}>
        <motion.div
          style={{ width: "100%" }}
          animate={{ marginTop: waveflowInput ? "0" : "30vh" }}
          transition={{ duration: 0.5 }}
        >
          <VStack w={"90%"} m={"auto"}>
            <Textarea
              id="queryInput"
              value={queChat}
              ref={waveflowRef}
              onChange={handleQueryWaveFlow}
              onKeyDown={handleKeyDown}
              placeholder="Explain the task, and we'll build your AI Co-workers"
              bg="gray.50"
              w={"100%"}
              minH={"80px"}
              // minH={waveflowInput ? "45px" : "80px"}
              // minH={"45px"}
              maxH={"100px"}
              isRequired
              border={"1px solid lightgray"}
            />
            {errorEmptyInput && (
              <Text fontSize={"14px"} fontWeight={500} color="red.500">
                {errorEmptyInput}
              </Text>
            )}

            {queChat !== "" && (
              <motion.div initial="hidden" animate="visible" variants={fadeIn}>
                <Flex gap={4}>
                  <Button
                    onClick={enhancePrompHandle}
                    border={"1px solid gray"}
                    variant="outline"
                    id="improvePromptButton"
                    size={"xs"}
                    isDisabled={loading}
                  >
                    {enahancePromptLoading ? (
                      <>
                        <Spinner size="sm" mr="10px" />
                        Improving
                      </>
                    ) : (
                      <>
                        <Image src={preetyy} mr={"10px"} />
                        Magic Prompt
                      </>
                    )}
                  </Button>
                  <Button
                    size={"xs"}
                    color={"white"}
                    id="generateButton"
                    onClick={handleSubmit}
                    bgGradient="linear(to-r, purple.500, blue.500)"
                    _hover={{
                      bg: "",
                    }}
                    isDisabled={loading}
                  >
                    <Image src={generate} mr={"10px"} />
                    Generate
                  </Button>
                </Flex>
              </motion.div>
            )}
          </VStack>
        </motion.div>
        {/* {error &&  dataset?.length <= 0 && (
          <Box w={"90%"} m={"auto"} mt={"20px"}>
            <HStack spacing={2}>
              <WarningIcon color="red.500" boxSize={4} />
              <Text fontSize={"14px"} fontWeight={500} color="red.500">
                {error || "Something went wrong, agent is not created."}
              </Text>
            </HStack>
          </Box>
        )} */}
        {waveflowInput && (
          <>
            <Box
              borderRadius={"lg"}
              h={"60vh"}
              sx={{ ...commonStyle.sx }}
              w="90%"
              boxSizing={"border-box"}
            >
              {dataset?.length > 0 && (
                <Box w={"100%"} m={"auto"} mb={"10px"}>
                  <Text fontSize={"x-large"} fontWeight={500}>
                    Generated AI Co-Workers
                  </Text>
                </Box>
              )}

              {dataset?.length < 0 || (loading && <LoadingForWaveFlow />)}
              {dataset && dataset?.length > 0 && (
                <Box
                  w={"100%"}
                  h={"90%"}
                  overflowY="auto"
                  sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
                >
                  <Grid
                    templateColumns={`repeat(5, 1fr)`}
                    gap={3}
                    w={"100%"}
                    m={"auto"}
                    mb={"10px"}
                  >
                    {/* {dataset &&
                      dataset?.map((ele, index) =>
                        ele?.type == "tool" ? (
                          <PreDefinedTool
                            name={ele?.tool_key}
                            desc={ele?.description}
                            image={ele?.tool_details?.logo}
                          />
                        ) : (
                          <Card
                            borderRadius={"20px"}
                            bg={"gray.100"}
                            justifyContent={"space-between"}
                            border={"1px solid lightgray"}
                          >
                            <VStack
                              align="start"
                              p={1}
                              box
                              boxSizing={"border-box"}
                            >
                              <HStack align="center" spacing={3}>
                                <Avatar
                                  size={"sm"}
                                  name={ele.name}
                                  color={"black"}
                                />
                                <Text fontSize={"12px"} fontWeight="semibold">
                                  {ele.name}
                                </Text>
                              </HStack>
                              <Stack
                                fontSize={"12px"}
                                align="start"
                                spacing={0}
                              >
                                <Text>{ele.role}</Text>
                                <Text color="gray.500">
                                  {truncateText(ele.description, 100)}
                                </Text>
                              </Stack>
                            </VStack>
                            <HStack w={"100%"} justifyContent={"flex-end"}>
                              <DownloadJsonFile dataDownload={ele} />
                            </HStack>
                          </Card>
                        )
                      )} */}
                    {dataset &&
                      dataset?.map(
                        (ele, index) =>
                          (ele?.type == "agent" ||
                            ele?.type == "executor node") && (
                            <Card
                              borderRadius={"20px"}
                              bg={"gray.100"}
                              justifyContent={"space-between"}
                              border={"1px solid lightgray"}
                            >
                              <VStack
                                align="start"
                                p={1}
                                box
                                boxSizing={"border-box"}
                              >
                                <HStack align="center" spacing={3}>
                                  <Avatar
                                    size={"sm"}
                                    name={ele.name}
                                    color={"black"}
                                  />
                                  <Text fontSize={"12px"} fontWeight="semibold">
                                    {ele.name}
                                  </Text>
                                </HStack>
                                <Stack
                                  fontSize={"12px"}
                                  align="start"
                                  spacing={0}
                                >
                                  <Text>{ele.role}</Text>
                                  <Text color="gray.500">
                                    {truncateText(ele.description, 100)}
                                  </Text>
                                </Stack>
                              </VStack>
                              <HStack w={"100%"} justifyContent={"flex-end"}>
                                <DownloadJsonFile dataDownload={ele} />
                              </HStack>
                            </Card>
                          )
                      )}
                  </Grid>
                </Box>
              )}
            </Box>
          </>
        )}
      </VStack>
    </>
  );
}

export default Waveflow;
